import * as React from 'react';
import { useRef, useMemo } from 'react';
import { Link } from 'gatsby';
import { classNames, getHardcodedPathByLocaleCode } from '../../utils';
import useClickOutside from '../../hooks/useClickOutside';
import ArrowDown from '../../icons/arrowDown';

const LanguageSwitcher = ({
  siblingsPages,
  languageSwitcher,
  languageSwitcherAriaLabel,
  currentLocaleCode,
  handleVisibilityLanguageSwitcher,
  handleCloseLanguageSwitcher,
  openLanguageSwitcher,
  setOpenLanguageSwitcher,
  notVisibleElements,
}) => {
  const languageSwitcherRef = useRef(null);

  useClickOutside(languageSwitcherRef, handleCloseLanguageSwitcher(false));

  React.useEffect(() => {
    if (openLanguageSwitcher) {
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          e.preventDefault();
          setOpenLanguageSwitcher(false);
        }
      })
    }
  }, [openLanguageSwitcher]);

  const { items, currentLanguageLetters } = useMemo(() => {
    return {
      items: languageSwitcher
        ?.map(({ title, locale_code }) => ({
          title,
          url: siblingsPages?.find(({ locale }) => locale === locale_code)?.url,
          home: getHardcodedPathByLocaleCode('home', locale_code),
          locale_code,
        }))
        ?.filter(({ locale_code }) => locale_code !== currentLocaleCode),

      currentLanguageLetters: languageSwitcher?.find(
        ({ locale_code }) => locale_code === currentLocaleCode
      )?.title,
    };
  }, [languageSwitcher]);

  return (
    <div
      className="language-switcher"
      ref={languageSwitcherRef}
      onMouseEnter={!notVisibleElements ? handleCloseLanguageSwitcher(true) : undefined}
      onMouseLeave={!notVisibleElements ? handleCloseLanguageSwitcher(false) : undefined}
      aria-expanded={openLanguageSwitcher}
    >
      <button
        type="button"
        className="language-switcher__button"
        aria-label={languageSwitcherAriaLabel}
        onClick={handleVisibilityLanguageSwitcher}
        onFocus={handleVisibilityLanguageSwitcher}
      >
        <span>{currentLanguageLetters}</span>
        <span aria-hidden="true">
        <ArrowDown
          className={classNames(
            'language-switcher__icon',
            openLanguageSwitcher ? 'language-switcher__icon--open' : ''
          )}
        />
        </span>
      </button>
      <div
        className={classNames(
          'language__categories',
          openLanguageSwitcher ? 'language__categories--open' : ''
        )}
      >
        {items?.map(({ title, url, home }) => (
          <Link key={title} className="language__category" to={url || home} onBlur={() => setOpenLanguageSwitcher(false)}>
            {title}
          </Link>
        ))}
      </div>
    </div>
  );
};

export default LanguageSwitcher;
